import React from 'react';
import { pastilleMcp } from '../constants/activite';

/**
 * Le détail d'une action MCP : la source interrogée — ou, à défaut, l'opération — et l'échec.
 *
 * Les deux écrans d'usage (Statistiques, pour une organisation ; Admin, pour tout le parc)
 * affichent la même ligne à partir des mêmes données : la rendre ici évite qu'une correction
 * n'en touche qu'une moitié, comme c'était le cas de la pastille vide que ce composant remplace.
 *
 * L'échec mérite sa propre pastille : les requêtes sans source **sont** des échecs — seul
 * `journalMcp` en enregistre, et il ne journalise que ce qui a raté. Sans la dire, l'écran
 * montrerait une opération anodine là où il y a eu une erreur.
 */
const BadgeMcp = ({ details }) => {
  const pastille = pastilleMcp(details);

  return (
    <>
      {pastille && (
        <span className="mcp-source-badge" style={{ background: pastille.couleur }}>
          {pastille.texte}
        </span>
      )}
      {details?.success === false && <span className="mcp-echec-badge">Échec</span>}
    </>
  );
};

export default BadgeMcp;
